import { ContentWrapper } from 'components/ContentWrapper';
import Page from 'components/Page';
import { Spinner } from 'components/Spinner';
import * as React from 'react';
import { prerenderedLoadable } from 'utils/prefetch';
const ForgotPasswordRaw = prerenderedLoadable(() => import(/* webpackChunkName: "ForgotPasswordPage" */ './Page'));
export const ForgotPassword = () => (React.createElement(Page, { title: "Forgot password ?", description: "Password forgot" },
    React.createElement(ContentWrapper, null,
        React.createElement(React.Suspense, { fallback: React.createElement(Spinner, { full: true }) },
            React.createElement(ForgotPasswordRaw, null)))));
